// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"Breadcrumb_breadcrumb__gDaws","SearchBox":"Breadcrumb_SearchBox__1JGMr"};